import React, { Component } from "react"
import * as styles from "./categoryItem.module.scss"

class CategoryItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false,
    }
  }

  componentDidMount() {
    this.updateViewport()
    window.addEventListener("resize", this.updateViewport)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateViewport)
  }

  updateViewport = () => {
    this.setState({ isMobile: window.innerWidth < 568 })
  }

  render() {
    const { category, setActiveCategory, activeCategory } = this.props
    return (
      <li
        id={category.name}
        onClick={setActiveCategory}
        className={styles.categoryItem}
        style={
          activeCategory === category.name && this.state.isMobile
            ? { background: "#e9e9e9" }
            : null
        }
      >
        {category.label}
        <span
          className="material-icons"
          id={
            activeCategory === category.name
              ? styles.chevron
              : styles.chevronHidden
          }
        >
          chevron_right
        </span>
      </li>
    )
  }
}

export default CategoryItem
